import Vue from "vue";
import {
  errorServeiceHandler,
  makeQueryStringDync,
  makeQueryFormDataDyn
} from "../../helper";
const state = {
  stbData: undefined,
  smcData: undefined,
  accountDetails: undefined,
  tempData: undefined,
  typeSelected: undefined,
  boxNumber: undefined
};
const getters = {
  getStbData: state => {
    return state.stbData;
  },
  getSmcData: state => {
    return state.smcData;
  },
  getChangePassword: state => {
    return state.changePassword;
  },
  getAccountDetails: state => {
    return state.accountDetails;
  },
  getTempData: state => {
    return state.tempData;
  },
  getTypeSelected: state => {
    return state.typeSelected;
  },
  getBoxNumber: state => {
    return state.boxNumber;
  }
};
const mutations = {
  setStbData: (state, data) => {
    state.stbData = data;
    console.log("setStbData", data);
  },
  setSmcData: (state, data) => {
    state.smcData = data;
  },
  setAccountDetails: (state, data) => {
    state.accountDetails = data;
  },
  setChangePassword: (state, data) => {
    state.changeNumber = data;
  },
  setTempData: (state, data) => {
    state.tempData = data;
  },
  setTypeSelected: (state, data) => {
    state.typeSelected = data;
  },
  setBoxNumber: (state, data) => {
    state.boxNumber = data;
  }
};
const actions = {
  actGetSubscriberValidate: (context, payload) => {
    return new Promise((resolve, reject) => {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      let data = makeQueryFormDataDyn(payload);
      fetch(context.getters.baseUrl + "/subscriber/v1/subscriber/validate", {
        method: "POST",
        body: data
      })
        .then(errorServeiceHandler)
        .then(response => {
          return response.json();
        })
        .then(data => {
          resolve(data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  changeUserAccountDetails: (context, payload) => {
    return new Promise((resolve, reject) => {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      let data = makeQueryFormDataDyn(payload);
      fetch(context.getters.baseUrl + "/subscriber/v1/subscriber/childdetails", {
        method: "POST",
        body: data
      })
        .then(errorServeiceHandler)
        .then(response => {
          return response.json();
        })
        .then(data => {
          resolve(data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  changeToParentDetails: (context) => {
    return new Promise((resolve, reject) => {
      fetch(context.getters.baseUrl + "/subscriber/v1/subscriber/deletechilddetails", {
        method: "POST",
      })
        .then(errorServeiceHandler)
        .then(response => {
          return response.json();
        })
        .then(data => {
          resolve(data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  actPostSubscriberDetails: (context, payload) => {
    return new Promise((resolve, reject) => {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      delete payload.changeNumber;
      let data = makeQueryFormDataDyn(payload);
      fetch(context.getters.baseUrl + "/subscriber/v1/subscriber", {
        method: "POST",
        body: data
      })
        .then(errorServeiceHandler)
        .then(response => {
          return response.json();
        })
        .then(data => {
          resolve(data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  
  actregionRegister:(context,payload) => {
    let key = ''
    if (context.getters.getServer == "test") {
      key =  'key=AAAASuKqmzg:APA91bEg3-eFiXPNucqTCR1FM2D0f8bs0Kf6RKpR5lAmVsglcwgtT6p8A3Qp6x6FLVFA8eFFtKpn1Mjhy6h0lYhDDJUubEqAMc8oB7-DnmjSbWj9P85a_xNtHzSYwfv7YCYv3P-TLUO1'
    } else {
      key =  'key=AAAAVDulBSI:APA91bHZZDfrIh5rO5fYpup8pTvEDtdfghg9MD5RaJ4LNBGNJe-sTl1G9YATovZbQ4rn0UlRoYMQx3bUnwbm3VCfRD0O46uxUkdlqOUUTSWWDF9kCdz9JyluqPwE9GZ-zJ-Wnwn4W5Ik'
    }
    return new Promise( (resolve, reject) => {
    fetch('https://iid.googleapis.com/iid/v1/'+payload.token+'/rel/topics/'+payload.region, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': key
            }
        })
        .then((response) => {
            return response.json()
        }).then((data) => {
            resolve(data)
        }).catch((error) => {
            reject(error)
        })
    });
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/account/registration.js